import { createSlice } from "@reduxjs/toolkit";
import { getPaymentReceive } from "../reduxApi/PaymentReceiveReduxApi";

const paymentReceiveSlice = createSlice({
    name: 'purchaseReceive',
    initialState: {
        status: 'idel',
        purchaseReceive: [],
    },
    reducers: {
        deletePaymentReceiveAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.purchaseReceive.findIndex((item) => item.ROWID === id);
                if (index !== -1) {
                    state.purchaseReceive.splice(index, 1);
                }
            });
        },
        updatePaymentReceiveAction: (state, action) => {
            console.log("action", action.payload);
            const index = state.purchaseReceive.findIndex(
                (item) => item?.ROWID === action.payload.paymentReceiveId
            );
            if (index !== -1) {
                state.purchaseReceive.splice(index, 1, action.payload.formData);
            }
        },

        addPaymentReceiveAction: (state, action) => {
            console.log("Adding purchaseReceive:", action.payload);
            const temp = { ...action.payload.formData, ROWID: action.payload.ROWID };
            state.purchaseReceive.unshift(temp);
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getPaymentReceive.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getPaymentReceive.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("testing client Data", action.payload)
                state.purchaseReceive = action.payload.data.purchaseReceive;
            })
    }
})
export const { deletePaymentReceiveAction, updatePaymentReceiveAction, addPaymentReceiveAction } = paymentReceiveSlice.actions
export default paymentReceiveSlice.reducer